

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_dbp7ddbpmb = () => {
                    
                        if (document.querySelector('.beae-tevb4e25:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-tevb4e25:not([data-beae-bind])'),
                                
                                id: 'beae-tevb4e25',
                                isLive: true
                            });
                            document.querySelector('.beae-tevb4e25:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-qwlu5dpw:not([data-beae-bind])')) {
                            (function() {let e=this.$el,t=e.querySelector(".beae-shopify__feature-blog-wrapper[data-screen]"),o=e.querySelector(".beae-shopify__feature-blog--title[data-style]"),a=[],l=[],s="",n=["beae-style--left","beae-style--center","beae-style--right","beae-style--"],p=e.querySelector(".beae-shopify__feature-blog--title");t&&(s=t.getAttribute("data-screen"),s&&(a=JSON.parse(s))),window.addEventListener("resize",r.bind(this));function r(){if(!s)return;o&&(dt_style=o.getAttribute("data-style"),dt_style&&(l=JSON.parse(dt_style)));let d={};a.forEach((b,g)=>{let c=!1,u=g==a.length-1;if(g==0)c=window.matchMedia(`only screen and(min-width:${b.min+1}px)`);else{let _=`only screen and(max-width:${b.width}px)${u?"":`and(min-width:${b.min+1}px)`}`;c=window.matchMedia(_)}c&&c.matches&&(d=b)}),a[0].name!=d.name&&p&&(p.classList.remove(...n),p.classList.add(`beae-style--${l[d.name]}`))}}).call({
                                $el: document.querySelector('.beae-qwlu5dpw:not([data-beae-bind])'),
                                
                                id: 'beae-qwlu5dpw',
                                isLive: true
                            });
                            document.querySelector('.beae-qwlu5dpw:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_dbp7ddbpmb()
                } else {
                    window.beaePageJS.push(jsHandle_dbp7ddbpmb)
                }
            